export const limit = {
	checkinInAdvance: 120, // user can checkin only with {checkinInAdvace} minutes before start of booking,
	bookingsOverviewInAdvance: 365, //  In days. = limit to request bookings in booking overview page.
	aspenRequestInAdvance: 365, //  In days. = limit to request bookings in booking overview page.
	favoriteTimeInAdvance: 2000000000, // how many days (in ms) can a user book a favorite entity in advance - it is added because usually it is based on teakType, but we dont know which teakType to add the limit for favorites.
	maximumCharacterLimitMeetingName: 50, //chars
	maximumTextLimitTimeTrackerNotes: 500
};
